import { ILLBusinessCategory } from './business-category.model';
import { ILLGenericKeys, ILLCompany, IEstablishment, ISSDPConctact } from './index';

export class IER {
  erxmlns: string;
  erId: number;
  erRevisionId: number;
  majorRevision: number;
  minorRevision: number;
  workFlowStatus: number;
  splTitle: string;
  splVersion: string;
  splServiceType: ILLGenericKeys;
  setId: string;
  dunsNumber: string;
  modifiedByDate: string;
  modifiedByUser: string;
  isDraftMode: boolean;
  versionNumber: string;
  effectiveTime: Date;
  busCategory: ILLBusinessCategory;
  registrantCompany: ILLCompany;
  registrantContact: ISSDPConctact;
  establishments: IEstablishment[];
}
